import keyMirror from 'keymirror';
import { BRAND_NAME } from '../../services/Constants';

export const packagesActionTypes = keyMirror({
	GET_CHOOSE_PACKAGE: null,
	GET_CHOOSE_PACKAGE_SUCCESS: null,

	GET_MY_PACKAGE: null,
	GET_MY_PACKAGE_SUCCESS: null,
	GET_MY_PACKAGE_ERROR: null,

	CANCEL_SUBSCRIPTION_REQUEST: null,
	CANCEL_SUBSCRIPTION_SUCCESS: null,
	CANCEL_SUBSCRIPTION_ERROR: null,

	TOGGLE_REACTIVATE_SUBSCRIPTION_MODAL: null,

	CHOOSE_FREE_PACKAGE_REQUEST: null,
	CHOOSE_FREE_PACKAGE_ERROR: null,

	CLEAN_PACKAGES_STATE: null,

	REACTIVATE_SUBSCRIPTION_REQUEST: null,
	REACTIVATE_SUBSCRIPTION_SUCCESS: null,
	REACTIVATE_SUBSCRIPTION_ERROR: null,
});

export const getUspSections = (t) => [
	{
		title: t('packages.usp_section.usp_1.title'),
		description: t('packages.usp_section.usp_1.description'),
	},
	{
		title: t('packages.usp_section.usp_2.title'),
		description: t('packages.usp_section.usp_2.description'),
	},
	{
		title: t('packages.usp_section.usp_3.title'),
		description: t('packages.usp_section.usp_3.description', { brandName: BRAND_NAME }),
	},
];

export const getSelectedPackage = (packages, selectedPackageId) =>
	packages
		.filter((item) => item.price)
		.filter((el) => el.id === selectedPackageId)
		.map(({ id, identifier, name }) => ({
			id,
			identifier,
			name,
		}))[0];

export const checkForHighlightedItem = (packages) =>
	Array.isArray(packages) &&
	packages.some(
		(item) =>
			Array.isArray(item.usps) &&
			item.usps.some((usp) => usp && Object.hasOwn(usp, 'highlighted_info')),
	);
